module.exports = __webpack_public_path__ + "img/fond-histoire.e61a432f.jpg";